"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrophoneSelector = void 0;
var _JoinComponent = require("../JoinComponent.styled");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Component for selecting and testing the microphone input.
 * Displays a dropdown of available microphone devices and a volume meter.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.selectedAudioInputDevice - ID of the currently selected audio input device
 * @param {Array<Object>} props.audioInputDevices - List of available audio input devices
 * @param {Function} props.onMicrophoneChange - Callback for when microphone selection changes
 * @param {boolean} [props.disabled] - Whether the microphone selector should be disabled
 * @returns {React.Element} Rendered component
 */
var MicrophoneSelector = exports.MicrophoneSelector = function MicrophoneSelector(_ref) {
  var _audioInputDevices$fi;
  var selectedAudioInputDevice = _ref.selectedAudioInputDevice,
    audioInputDevices = _ref.audioInputDevices,
    onMicrophoneChange = _ref.onMicrophoneChange,
    disabled = _ref.disabled;
  var selectedGroupId = audioInputDevices === null || audioInputDevices === void 0 || (_audioInputDevices$fi = audioInputDevices.find(function (device) {
    return device.value === selectedAudioInputDevice;
  })) === null || _audioInputDevices$fi === void 0 ? void 0 : _audioInputDevices$fi.group;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledFormDropdown, {
    labelText: "Select and test microphone",
    "data-testid": "selectMicrophone",
    selected: selectedAudioInputDevice,
    options: audioInputDevices,
    id: "selectMicrophone",
    onChange: onMicrophoneChange,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledMicrophoneVolumeBar, {
    selectedAudioInputId: selectedAudioInputDevice,
    selectedGroupId: selectedGroupId,
    disabled: disabled
  }));
};
MicrophoneSelector.propTypes = {
  selectedAudioInputDevice: _propTypes["default"].string.isRequired,
  audioInputDevices: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    group: _propTypes["default"].string
  })).isRequired,
  onMicrophoneChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool
};